import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, FormControlLabel, Switch,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const DEFAULTS = { keyword: "", response: "", matchType: "contains", isActive: true };

const KeywordRuleModal = ({ open, onClose, rule, onSave }) => {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setForm(rule ? { keyword: rule.keyword, response: rule.response, matchType: rule.matchType, isActive: rule.isActive } : DEFAULTS);
  }, [open, rule]);

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSave = async () => {
    if (!form.keyword.trim() || !form.response.trim()) {
      toast.error("Preencha a palavra-chave e a resposta.");
      return;
    }
    setLoading(true);
    try {
      const { data } = rule
        ? await api.put(`/keyword-rules/${rule.id}`, form)
        : await api.post("/keyword-rules", form);
      onSave(data);
      toast.success(rule ? "Regra atualizada." : "Regra criada.");
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{rule ? "Editar regra" : "Nova regra de auto-resposta"}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "12px !important" }}>
        <TextField
          label="Palavra-chave / frase"
          value={form.keyword}
          onChange={set("keyword")}
          fullWidth
          size="small"
          helperText="A mensagem do cliente precisa conter / ser igual a esta palavra"
        />
        <TextField
          label="Tipo de correspondência"
          select
          value={form.matchType}
          onChange={set("matchType")}
          fullWidth
          size="small"
        >
          <MenuItem value="contains">Contém</MenuItem>
          <MenuItem value="startsWith">Começa com</MenuItem>
          <MenuItem value="exact">Exato</MenuItem>
        </TextField>
        <TextField
          label="Resposta automática"
          value={form.response}
          onChange={set("response")}
          fullWidth
          multiline
          minRows={3}
          size="small"
        />
        <FormControlLabel
          control={<Switch checked={form.isActive} onChange={(e) => setForm(f => ({ ...f, isActive: e.target.checked }))} color="primary" />}
          label="Regra ativa"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
          {loading ? "Salvando..." : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KeywordRuleModal;
